var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { BaseComponent } from "../../views/base.component";
import { EventsService } from "../../lib/EventsService";
import { FilterFormService } from "../../views/filter_form/filter_form.service";
import { TranslateService } from "../../translate";
import { ActivatedRoute, Router } from "@angular/router";
import { ApiService } from "../api.service";
import { ChartParams } from "../../views/chart/chart.component";
import { FilterParams } from "../../models/filter_form.model";
import merge from "lodash-es/merge";
import * as qs from 'qs';
var PerfomanceComponent = /** @class */ (function (_super) {
    __extends(PerfomanceComponent, _super);
    function PerfomanceComponent(eventsService, service, route, filter, translate, router) {
        var _this = _super.call(this, eventsService, service, route, filter, translate) || this;
        _this.eventsService = eventsService;
        _this.service = service;
        _this.route = route;
        _this.filter = filter;
        _this.translate = translate;
        _this.router = router;
        _this.stats = [];
        _this.addFilterParams = {
            dateFilters: ['datePaid', 'dateCreated', 'dateSiteCreated', 'dateTo', 'datePublished'],
            isRegDay: true,
            userType: 'user',
            dateType: 'dateCreated'
        };
        _this.chartData = new ChartParams();
        return _this;
    }
    PerfomanceComponent.prototype.getData = function () {
        return __awaiter(this, void 0, void 0, function () {
            var me, fp, stats;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        me = this;
                        me.isLoad = true;
                        fp = me.filter.getCopyFilterParams();
                        fp.level = 'group';
                        return [4 /*yield*/, me.service.perfomance.stats(fp).toPromise()];
                    case 1:
                        stats = (_a.sent()).stats;
                        me.stats = stats;
                        me.isLoad = false;
                        return [2 /*return*/];
                }
            });
        });
    };
    // Возможно нам подзодит стандартный bootstrap-класс
    // https://getbootstrap.com/docs/4.0/utilities/spacing/
    // pl-4 и далее
    PerfomanceComponent.prototype.getRefererStyle = function (stat) {
        if (stat.level === 'group') {
            return '';
        }
        if (stat.level === 'lang') {
            return 'pl-4';
        }
        return 'pl-5';
    };
    PerfomanceComponent.prototype.showSource = function (stat, i) {
        return __awaiter(this, void 0, void 0, function () {
            var me, fp, level, stats;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        me = this;
                        if (stat.isOpened) {
                            // close
                            me.stats.splice(i + 1, stat.refs.length);
                            stat.isOpened = false;
                            return [2 /*return*/];
                        }
                        stat.isOpened = true;
                        fp = me.filter.getCopyFilterParams();
                        level = stat.level;
                        switch (stat.level) {
                            case 'group':
                                fp.inGroup = stat.refGroup;
                                level = 'lang';
                                fp.level = level;
                                break;
                            case 'lang':
                                fp.inGroup = stat.refGroup;
                                fp.lang = stat.joinId;
                                level = 'campaign';
                                fp.level = level;
                                break;
                            default:
                                break;
                        }
                        stat.isLoad = true;
                        return [4 /*yield*/, me.service.perfomance.stats(fp).toPromise()];
                    case 1:
                        stats = (_a.sent()).stats;
                        stat.refs = stats.map(function (r) {
                            r.level = level;
                            return r;
                        });
                        stat.isLoad = false;
                        me.stats = me.stats.slice(0, i + 1).concat(stat.refs.map(function (ref) {
                            ref.inGroup = stat.refGroup;
                            return ref;
                        }), me.stats.slice(i + 1));
                        return [2 /*return*/];
                }
            });
        });
    };
    PerfomanceComponent.prototype.applyFilters = function () {
        return __awaiter(this, void 0, void 0, function () {
            var params, url;
            return __generator(this, function (_a) {
                params = this.filter.getApplyFilters(this.filter.filterParams), url = this.router.url.split('?')[0];
                params = qs.stringify(params, { encode: false });
                this.router.navigateByUrl(url + "?" + params, { relativeTo: this.route });
                return [2 /*return*/];
            });
        });
    };
    PerfomanceComponent.prototype.resetFilters = function () {
        return __awaiter(this, void 0, void 0, function () {
            var params, url;
            return __generator(this, function (_a) {
                this.filter.filterParams = new FilterParams();
                this.filter.filterParams = merge({}, this.filter.filterParams, this.filter.addFilterParams);
                this.filter.filterParams.dateFilterParams = this.filter.getDateFilterParams(this.filter.filterParams, this.filter.addFilterParams);
                params = merge({}, this.filter.getDiffParams(this.filter.filterParams)), url = this.router.url.split('?')[0];
                delete params.dateFilters;
                delete params.dateFilterParams;
                this.router.navigate([url], { relativeTo: this.route, queryParams: params });
                return [2 /*return*/];
            });
        });
    };
    return PerfomanceComponent;
}(BaseComponent));
export { PerfomanceComponent };
